import { createTheme } from "@mui/material/styles";

const formLabelComponent = {
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: 18,
      },
    },
  },
};

const typographyComponent = {
  MuiTypography: {
    styleOverrides: {
      body1: {
        fontSize: 13,
      },
    },
  },
};

const button = {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      textPrimary: {
        color: "#000000",
        "&:hover": {
          color: "#00db8f",
        },
      },
      root: {
        fontFamily: ["Inter", "Helvetica Neue", "sans-serif"].join(", "),
      },
    },
  },
};

const cssBaseline = {
  MuiCssBaseline: {
    styleOverrides: `@font-face {
        font-family: 'Inter',
        font-style: normal
      }`,
  },
};

const typography = {
  fontFamily: "Inter",
};

const palette = {
  primary: {
    main: "#000000",
  },
  secondary: {
    main: "#00db8f",
  },
  error: {
    main: "#d32f2f",
  },
  background: {
    default: "#ffffff",
  },
};

export const globalStyles = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 768,
      lg: 1024,
      xl: 1366,
    },
  },
  components: {
    ...formLabelComponent,
    ...typographyComponent,
    ...button,
    ...cssBaseline,
  },
  typography,
  palette,
});
